import styled from 'styled-components/macro';
import { IFontSize } from '../../types/styled';
import imageEmptySubscriptions from './assets/subscription.png';
import imageEmptyDatabases from './assets/database.png';

export type Logo = 'subscription' | 'database';

const emptyLogos: { [K in Logo]: string } = {
  subscription: imageEmptySubscriptions,
  database: imageEmptyDatabases
};

export const Container = styled.div<{ marginTop: string }>`
  margin-top: ${({ marginTop }) => marginTop};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  position: relative;
`;

export const Label = styled.p<{ fontSize: IFontSize; bold: boolean }>`
  white-space: pre-wrap;
  color: ${({ theme }) => theme.appComponents.components.emptyListsFallback.label.color};
  font-size: ${({ fontSize, theme }) =>
    theme.appComponents.components.emptyListsFallback.label.fontSize[fontSize]};
  font-weight: ${({ theme, bold }) =>
    bold ? theme.core.font.fontWeight.semiBold : theme.core.font.fontWeight.normal};
`;

export const Description = styled.p<{ fontSize: IFontSize }>`
  white-space: pre-wrap;
  color: ${({ theme }) => theme.appComponents.components.emptyListsFallback.description.color};
  font-size: ${({ fontSize, theme }) =>
    theme.appComponents.components.emptyListsFallback.description.fontSize[fontSize]};
  margin-top: 0.8rem;
`;

export const LogoIcon = styled.div<{ logo: Logo }>`
  width: 22rem;
  height: 22rem;
  background-image: url(${({ logo }) => emptyLogos[logo]});
  background-size: contain;
  background-position: 50%;
  margin-bottom: 2.4rem;
  position: absolute;
  bottom: 100%;
`;

export const ButtonContainer = styled.div`
  margin-top: 2.4rem;
`;
